import React from "react";
import { ReactComponent as Icon } from "../../../../../assets/icons/tarifs/crown.svg";

function Crown({ width = "90px", className = "" }) {
  return <Icon width={width} height={"calc(" + width + "* 0.75)"} className={className} />;
}

export default Crown;
